import gql from 'graphql-tag';

const SelfAssignDriver = gql(/* GraphQL */ `
  mutation SelfAssignDriver($input: SelfAssignDriverInput!) {
    selfAssignDriver(input: $input) {
      driverAssignmentId
      userErrors {
        ... on UserError {
          message
        }
      }
    }
  }
`);

export default SelfAssignDriver;
